import { ModelBase } from 'store/model-base';

export class CmsCore extends ModelBase {
    public static storeName: string = 'cmsCore';

    public modals: SiteModals;
    public metaData: SiteMetaData;
    public footer: SiteFooter;
    public nav: SiteNav;
    public icons: CmsIcons;
    public carousel: CmsCarousel;
    public schema: CmsSchema;
}
